export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'yolo-theme';

export const getSystemPreference = (): ResolvedTheme =>
  window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const resolveTheme = (mode: ThemeMode): ResolvedTheme =>
  mode === 'system' ? getSystemPreference() : mode;

export const applyTheme = (resolved: ResolvedTheme) => {
  document.documentElement.setAttribute('data-theme', resolved);
  document.documentElement.style.colorScheme = resolved;
};

export const formatLabel = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const getThemeLabel = (mode: ThemeMode, resolved: ResolvedTheme) =>
  mode === 'system' ? `System (${formatLabel(resolved)})` : formatLabel(mode);
